var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "update-questions-modal",
        title: "Update Questions",
        "header-bg-variant": "projects",
        centered: "",
        "hide-footer": "",
        size: "lg"
      }
    },
    [
      _c(
        "div",
        { staticClass: "update-questions" },
        [
          _c("p", { staticClass: "update-intro" }, [
            _vm._v("\n      Changes apply to all "),
            _c("strong", [_vm._v(_vm._s(_vm.questionsSelected.length))]),
            _vm._v(
              " selected questions.\n      Leave a field blank to keep its current value.\n    "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "selected-questions" }, [
            _c(
              "button",
              {
                staticClass: "selected-toggle is-summary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.listOpen = !_vm.listOpen
                  }
                }
              },
              [
                _c("b-icon", {
                  attrs: {
                    icon: _vm.listOpen ? "chevron-down" : "chevron-right",
                    size: "is-small"
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "selected-toggle-label" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.questionsSelected.length) +
                      " question" +
                      _vm._s(_vm.questionsSelected.length !== 1 ? "s" : "") +
                      " selected\n          across " +
                      _vm._s(_vm.selectedGroups.length) +
                      " categor" +
                      _vm._s(_vm.selectedGroups.length !== 1 ? "ies" : "y") +
                      "\n        "
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.listOpen,
                    expression: "listOpen"
                  }
                ],
                staticClass: "selected-tree"
              },
              _vm._l(_vm.selectedGroups, function(primary) {
                return _c(
                  "div",
                  { key: primary.key, staticClass: "selected-group" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "selected-toggle is-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.toggle(primary.key)
                          }
                        }
                      },
                      [
                        _c("b-icon", {
                          attrs: {
                            icon: _vm.isCollapsed(primary.key)
                              ? "chevron-right"
                              : "chevron-down",
                            size: "is-small"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "selected-toggle-label" }, [
                          _vm._v(_vm._s(primary.name))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "selected-count" }, [
                          _vm._v(_vm._s(primary.count))
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isCollapsed(primary.key),
                            expression: "!isCollapsed(primary.key)"
                          }
                        ]
                      },
                      _vm._l(primary.secondaries, function(secondary) {
                        return _c("div", { key: secondary.key }, [
                          secondary.name
                            ? _c(
                                "button",
                                {
                                  staticClass: "selected-toggle is-secondary",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.toggle(secondary.key)
                                    }
                                  }
                                },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: _vm.isCollapsed(secondary.key)
                                        ? "chevron-right"
                                        : "chevron-down",
                                      size: "is-small"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "selected-toggle-label" },
                                    [_vm._v(_vm._s(secondary.name))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "selected-count" },
                                    [_vm._v(_vm._s(secondary.questions.length))]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "ul",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.isCollapsed(secondary.key),
                                  expression: "!isCollapsed(secondary.key)"
                                }
                              ],
                              class: { "is-nested": secondary.name }
                            },
                            _vm._l(secondary.questions, function(question) {
                              return _c("li", { key: question._id }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(question.text) +
                                    "\n                "
                                )
                              ])
                            }),
                            0
                          )
                        ])
                      }),
                      0
                    )
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c("h5", [_vm._v("Primary Category")]),
          _vm._v(" "),
          _c(
            "b-field",
            {
              attrs: {
                type: { "is-danger": _vm.primaryInvalid },
                message: { "Invalid category name!": _vm.primaryInvalid }
              }
            },
            [
              _c(
                "b-autocomplete",
                {
                  attrs: {
                    data: _vm.filteredPrimary,
                    placeholder: "Keep current primary category",
                    "open-on-focus": "",
                    clearable: ""
                  },
                  on: {
                    select: _vm.onPrimaryChanged,
                    blur: _vm.onPrimaryChanged
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(props) {
                        return [
                          _c("div", { staticClass: "result-item" }, [
                            _c("strong", [_vm._v(_vm._s(props.option))])
                          ])
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.form.primaryCategory,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "primaryCategory", $$v)
                    },
                    expression: "form.primaryCategory"
                  }
                },
                [
                  _vm._v(" "),
                  _c("template", { slot: "empty" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.form.primaryCategory
                            ? "Creating new category: " +
                                _vm.form.primaryCategory
                            : "No existing categories"
                        ) +
                        "\n        "
                    )
                  ])
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("h5", [_vm._v("Secondary Category")]),
          _vm._v(" "),
          _c(
            "b-field",
            {
              attrs: {
                type: { "is-danger": _vm.secondaryInvalid },
                message: _vm.secondaryMessage
              }
            },
            [
              _c(
                "b-autocomplete",
                {
                  attrs: {
                    data: _vm.filteredSecondary,
                    placeholder: "Keep current secondary category",
                    "open-on-focus": "",
                    clearable: ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(props) {
                        return [
                          _c("div", { staticClass: "result-item" }, [
                            _c("strong", [_vm._v(_vm._s(props.option))])
                          ])
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.form.secondaryCategory,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "secondaryCategory", $$v)
                    },
                    expression: "form.secondaryCategory"
                  }
                },
                [
                  _vm._v(" "),
                  _c("template", { slot: "empty" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.form.secondaryCategory
                            ? "Creating new category: " +
                                _vm.form.secondaryCategory
                            : "No existing categories"
                        ) +
                        "\n        "
                    )
                  ])
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("h5", [_vm._v("Phase")]),
                  _vm._v(" "),
                  _c(
                    "b-select",
                    {
                      attrs: { expanded: "" },
                      model: {
                        value: _vm.form.phase,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "phase", $$v)
                        },
                        expression: "form.phase"
                      }
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v("\n            Keep current phase\n          ")
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.phaseCount, function(phase) {
                        return _c(
                          "option",
                          { key: phase, domProps: { value: phase } },
                          [
                            _vm._v(
                              "\n            " + _vm._s(phase) + "\n          "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("h5", [_vm._v("Required")]),
                  _vm._v(" "),
                  _c(
                    "b-select",
                    {
                      attrs: { expanded: "" },
                      model: {
                        value: _vm.form.required,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "required", $$v)
                        },
                        expression: "form.required"
                      }
                    },
                    [
                      _c("option", { domProps: { value: null } }, [
                        _vm._v("\n            Keep current setting\n          ")
                      ]),
                      _vm._v(" "),
                      _c("option", { domProps: { value: true } }, [
                        _vm._v("\n            Required\n          ")
                      ]),
                      _vm._v(" "),
                      _c("option", { domProps: { value: false } }, [
                        _vm._v("\n            Not required\n          ")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-actions d-flex justify-content-end" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mr-3",
                  attrs: { variant: "danger" },
                  on: { click: _vm.hide }
                },
                [
                  _c("b-icon", {
                    staticClass: "mr-2",
                    attrs: { icon: "close" }
                  }),
                  _vm._v("\n        Cancel\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "success",
                    disabled: !_vm.hasChanges || _vm.invalid || _vm.saving
                  },
                  on: { click: _vm.submit }
                },
                [
                  _vm.saving
                    ? _c("b-spinner", {
                        staticClass: "mr-2",
                        attrs: { small: "" }
                      })
                    : _c("b-icon", {
                        staticClass: "mr-1",
                        attrs: { icon: "check-circle" }
                      }),
                  _vm._v(
                    "\n        Update " +
                      _vm._s(_vm.questionsSelected.length) +
                      " Question" +
                      _vm._s(_vm.questionsSelected.length !== 1 ? "s" : "") +
                      "\n      "
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }